// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__20HYa","label":"LabeledBox_label__18tAl"};